import apiService from "@/plugins/ApiService";

export default function(station, format, query = 'pls') {
    apiService.query(`public/playlist/${station.id}/${query}`, { responseType: 'blob' })
        .then(response => {
            const blob = new Blob([response.data], { type: format })
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            link.download = station.short_name
            link.click()
            URL.revokeObjectURL(link.href)
        }).catch(console.error)
}